import { render, staticRenderFns } from "./deanWidget.vue?vue&type=template&id=0e1614ac&scoped=true"
import script from "./deanWidget.vue?vue&type=script&lang=ts"
export * from "./deanWidget.vue?vue&type=script&lang=ts"
import style0 from "./deanWidget.vue?vue&type=style&index=0&id=0e1614ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1614ac",
  null
  
)

export default component.exports